module.exports = __webpack_public_path__ + "static/img/blindfold.58ce4239.png";